// 샘플데이터 API
import axiosInstance from './axiosInstance';

export const getSampleSourceUsers = () =>
  axiosInstance.get('/sample-data/source-users').then(r => r.data);

export const getSourceUserAccounts = (userId) =>
  axiosInstance.get('/sample-data/accounts', { params: { user_id: userId } }).then(r => r.data);

export const getSampleConfig = () =>
  axiosInstance.get('/sample-data/config').then(r => r.data);

export const updateSampleConfig = (body) =>
  axiosInstance.put('/sample-data/config', body).then(r => r.data);
